import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import * as analysisActions from "../../redux/actions/analysis";
import { Button } from "../../components/widgets";
import Page from "../../components/layout/Page";
import Permissions from "../../permissions";
import AnalysisDataExportsList from "./AnalysisDataExportsList";
import { accessTokenItemName } from "../../redux/actions/user";
import OperationalExport from "./AnalysisDataOperationalExport";
import CustomerExport from "./AnalysisDataCustomerExport";
import AnalysisDataChooseExport from "../../components/analysis/ChooseExportModal";

export const OPERATIONAL_EXPORT_TYPE_DEPLOYMENT = "deployment";
export const OPERATIONAL_EXPORT_TYPE_POWERSTATION = "powerstation";

const mapStateToProps = state => ({
  analysis: state.analysis,
  user: state.user,
});

const mapDispatchToProps = dispatch => {
  return {
    analysisActions: bindActionCreators(analysisActions, dispatch),
  };
};

class AnalysisExportCSV extends Component {
  componentDidMount = () => {
    this.props.analysisActions.fetchCSVDataExports(this.props.user.account.id);
    this.refreshExports = setInterval(
      () => this.props.analysisActions.fetchCSVDataExports(this.props.user.account.id),
      30000
    );
    // If a deploymentId is in the URL params, then open a deployment export modal
    const queryParams = new URLSearchParams(window.location.search);
    const deploymentId = queryParams.get("deploymentId");
    if (deploymentId) {
      this.setState({
        ...this.state,
        operationalExportType: OPERATIONAL_EXPORT_TYPE_DEPLOYMENT,
        openOperationalModal: true,
      });
    }
  };

  componentWillReceiveProps = nextProps => {
    clearInterval(this.refreshExports);
    if (nextProps.analysis.exports) {
      if (
        nextProps.analysis.exports.data[0].status === "PROGRESS" ||
        nextProps.analysis.exports.data[0].status === "PENDING"
      ) {
        this.refreshExports = setInterval(
          () => this.props.analysisActions.fetchCSVDataExports(this.props.user.account.id),
          5000
        );
      }
    }
  };

  componentWillUnmount = () => {
    this.props.analysis.exports = null;
    clearInterval(this.refreshExports);
  };

  constructor(props) {
    super(props);
    this.state = {
      openChooseExportTypeModal: false,
      operationalExportType: null,
    };
  }

  openChooseExportTypeModal = () => {
    this.setState({
      openChooseExportTypeModal: true,
    });
  };

  openDeploymentOperationalModal = () => {
    this.setState({
      openOperationalModal: true,
      operationalExportType: OPERATIONAL_EXPORT_TYPE_DEPLOYMENT,
      openChooseExportTypeModal: false,
    });
  };

  openPowerstationOperationalModal = () => {
    this.setState({
      openOperationalModal: true,
      operationalExportType: OPERATIONAL_EXPORT_TYPE_POWERSTATION,
      openChooseExportTypeModal: false,
    });
  };

  closeOperationalModal = () => {
    this.setState({
      openOperationalModal: false,
    });
  };

  openCustomerModal = () => {
    this.setState({
      openCustomerModal: true,
      openChooseExportTypeModal: false,
    });
  };

  closeCustomerModal = () => {
    this.setState({
      openCustomerModal: false,
    });
  };

  closeChooseExportTypeModal = () => {
    this.setState({
      openChooseExportTypeModal: false,
    });
  };

  render() {
    return (
      <Page permission={Permissions.fleet.analysis.export.view}>
        <Page.Header title="Data Export (csv)">
          <Page.Header.Actions>
            <Button
              id="new-export"
              type="primary"
              icon="plus"
              onClick={this.openChooseExportTypeModal}
              timezone={this.props.user.account.timezone}
            >
              New Export
            </Button>
          </Page.Header.Actions>
        </Page.Header>
        <Page.Content>
          <AnalysisDataExportsList
            exports={this.props.analysis.exports}
            timezone={this.props.user.account.timezone}
            accessToken={localStorage.getItem(accessTokenItemName)}
            noExports={this.props.analysis.noExports}
          />
          {this.state.openChooseExportTypeModal &&
          !(this.state.openOperationalModal || this.state.openCustomerModal) ? (
            <AnalysisDataChooseExport
              openPowerstationOperationalModal={this.openPowerstationOperationalModal}
              openDeploymentOperationalModal={this.openDeploymentOperationalModal}
              openCustomerModal={this.openCustomerModal}
              closeModal={this.closeChooseExportTypeModal}
              suborgType={this.props.user.account.suborg_type}
            />
          ) : null}
          {this.state.openOperationalModal ? (
            <OperationalExport
              closeModal={this.closeOperationalModal}
              suborgType={this.props.user.account.suborg_type}
              operationalExportType={this.state.operationalExportType}
              history={this.props.history}
              location={this.props.location}
            />
          ) : null}
          {this.state.openCustomerModal ? (
            <CustomerExport
              closeModal={this.closeCustomerModal}
              suborgType={this.props.user.account.suborg_type}
            />
          ) : null}
        </Page.Content>
      </Page>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AnalysisExportCSV));
